import { ProductTypeWithIdAndPrice } from '@/types';
import { getPriceStrategy } from '@/redux/core/getters/getPriceStrategy';
import { getQuantityDiscounts } from '@/redux/discounts/getters/getQuantityDiscounts';
import { StoreState } from '@/redux/types';
import { convertPriceIfNeeded } from './convertPriceIfNeeded';
import { isMdsPriceStrategy } from './isMdsPriceStrategy';

export const getProductTypePrice = (
  state: StoreState,
  productType: ProductTypeWithIdAndPrice,
  quantity = 1
): number => {
  const priceStrategy = getPriceStrategy(state);
  let productTypePrice = productType.price.vatIncluded;

  if (isMdsPriceStrategy(priceStrategy)) {
    const productTypeBasedCommissions = priceStrategy.productTypeBasedCommissions;
    if (productTypeBasedCommissions) {
      const productTypeCommission =
        productTypeBasedCommissions[productType.id] || productTypeBasedCommissions.DEFAULT;
      const productTypeCommissionAmount = productTypeCommission?.amount || 0;
      productTypePrice += productTypeCommissionAmount;
    }
  }

  if (quantity > 1) {
    const quantityDiscount = getQuantityDiscounts(state, quantity)?.[productType.id];
    if (quantityDiscount) {
      productTypePrice -= (productTypePrice * quantityDiscount.credit.value) / 100;
    }
  }

  return convertPriceIfNeeded(productTypePrice, state);
};
